import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        operationalHours: {
            gridColumn: '1 / -1',
        },
        isLunchBreak: {
            gridColumn: 'span 2',
        },
    }
})

export default useStyles
